import { connect } from "react-redux";
import ExportTimeSheet from "./ExportTimeSheet";
import {
  workerTimeSheetExportListRequest,
  exportTimesheetToPayrollRequest,
} from "store/actions/rostering.actions";
import {
  getExportTimesheetToPayrollLoader,
  getWorkerTimeSheetExportList,
  getWorkerTimeSheetExportListLoader,
} from "store/selector/rostering.selector";
import { getSpSetting } from "store/selector/sp.selector";
import { payrollAuthenticationUpdateLocally } from "store/actions/auth.actions";
import { getUser, getPayrollAuth } from "store/selector/auth.selector";

const mapDispatchToProps = {
  workerTimeSheetExportListRequest,
  payrollAuthenticationUpdateLocally,
  exportTimesheetToPayrollRequest,
};

const mapStateToProps = (state) => {
  const workerTimeSheetExportList = getWorkerTimeSheetExportList(state);
  const workerTimeSheetExportListLoader =
    getWorkerTimeSheetExportListLoader(state);
  const currentSpUser = getSpSetting(state);
  const currentLoginUser = getUser(state);
  const payrollAuth = getPayrollAuth(state);
  const exportTimesheetToPayrollLoader =
    getExportTimesheetToPayrollLoader(state);

  return {
    workerTimeSheetExportList,
    workerTimeSheetExportListLoader,
    currentSpUser,
    payrollAuth,
    exportTimesheetToPayrollLoader,
    currentLoginUser,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportTimeSheet);
